export const SIGNUP = '/signup';
export const LOGIN = '/login';
export const FORGOT_PASSWORD = '/forgot';
export const RESET_PASSWORD = '/reset';
